export const tagsRel ={
    headers:[
        { key: "cnpj", label: "CNPJ"},
        { key: "empresa", label: "Empresa"},
        { key: "ano", label: "Ano"},
        { key: "produto", label: "Produto"},
        //Combustível Renovável
        { key: "combustivelRenovavel", label: "Empresa consumiu combustível renovável neste ano de referência"},
        { key: "bagacoCana", label: "Bagaço de cana (GJ)"},
        { key: "etanolHidratado", label: "Etanol hidratado (GJ)"},
        { key: "lenha", label: "Lenha para queima direta (GJ)"},
        { key: "biodieselB100", label: "Biodiesel B100 (GJ)"},
        { key: "biogas", label: "Biogás (GJ)"},
        { key: "carvaoVegetal", label: "Carvão vegetal (GJ)"},
        { key: "residuosMunicipais", label: "Resíduos Municipais(fração biomassa)"},
        { key: "residuosVegetais", label: "Resíduos vegetais"},
        { key: "alcatraoVegetal", label: "Alcatrão vegetal"},
        { key: "outrosCr", label: "Outros Combustível Renovável"},
         //Combustivel não renovável
        { key: "combustivelNaoRenovavel", label: "Empresa consumiu combustível não-renovável neste ano de referência"},
        { key: "coqueCarvao", label: "Coque de carvão mineral (GJ)"},
        { key: "alcatraoMineral", label: "Alcatrão mineral (GJ)"},
        { key: "etanol", label: "Etanol (GJ)"},
        { key: "carvaoVapor", label: "Carvão vapor (GJ)"},
        { key: "coquePetroleo", label: "Coque de petróleo (GJ)"},
        { key: "gasPetroleo", label: "Gás liquefeitodo petróleo (GJ)"},
        { key: "gasNatural", label: "Gás Natural (GJ)"},
        { key: "gasGnv", label: "Gás natural veicular (GNV)(GJ)"},
        { key: "gasolinaAutomotiva", label: "Gasolina automotiva pura (GJ)"},
        { key: "gasolinaAviacao", label: "Gasolina de aviação (GJ)"},
        { key: "gasGnl", label: "Gás natural líquido (GNL)(GJ)"},
        { key: "lubrificantes", label: "Lubrificantes (GJ)"},
        { key: "oleoCombustivel", label: "Óleo combustível(GJ)"},
        { key: "oleoVisto", label: "Óleo de visto (GJ)"},
        { key: "oleoDieselPuro", label: "Óleo diesel puro (GJ)"},
        { key: "oleosResiduais", label: "Óleos Residuais (GJ)"},
        { key: "outrosPetroleo", label: "Outros produtos de petróleo (GJ)"},
        { key: "petroleo", label: "Petróleo bruto (GJ)"},
        { key: "queroseneAviacao", label: "Querosene de aviação (GJ)"},
        { key: "residuosIndustriais", label: "Resíduos industriais (GJ)"},
        { key: "residuosMunNr", label: "Resíduos municipais não-renovável (GJ)"},
        { key: "turfa", label: "Turfa (GJ)"},
        { key: "xistoAreias", label: "Xisto Betuminoso e Areias Betuminosas (GJ)"},
        { key: "outrosNr", label: " Outros não-renovável (GJ)"},
        //Eletricidade renovável
        { key: "eletricidadeRenovavel", label: "Empresa consumiu eletricidade renovável neste ano de referência"},
        { key: "biomassa", label: "Biomassa (GJ)"},
        { key: "biomassaMadeira", label: "Biomassa - cavaco de madeira (GJ)"},
        { key: "biomassaCana", label: "Biomassa - bagaço de cana (GJ)"},
        { key: "biomassaGramineas", label: "Biomassa - gra-míneas energéticas (GJ)"},
        { key: "biomassaAgricola", label: "Biomassa - resíduos agrícolas (GJ)"},
        { key: "biomassaOutros", label: "Biomassa - outros (GJ)"},
        { key: "eolicas", label: "Eólicas (GJ)"},
        { key: "solarFotovoltaica", label: "Solar fotovoltaica (GJ)"},
        { key: "hidreletricas", label: "Hidrelétricas (GJ)"},
        { key: "outrosEr", label: "Outros Energia renovável"},
         //Eletrcidade Nao-renovavel
        { key: "eletricidadeNaoRenovavel", label: "Empresa consumiu eletricidade não-renovável neste ano de referência"},
        { key: "carvao", label: "Carvão (GJ)"},
        { key: "gasNaturalEnr", label: "Gás natural não-renovável (GJ)"},
        { key: "nuclear", label: "Nuclear (GJ)"},
        { key: "oleoDiesel", label: "Óleo diesel (GJ)"},
        { key: "oleoEnr", label: "Óleo combustível (GJ)"},
        { key: "residuos", label: "Resíduos (GJ)"},
        { key: "coquePetroleoEnr", label: "Coque do petróleo (GJ)"},
        { key: "outrosEnr", label: "Outros Eletricidade não-renovável (GJ)"},
        // Eletricidade SIN
        { key: "eletricidadeSin", label: "Empresa consumiu eletricidade do Sistema Integrado Nacional(SIN) neste ano de referência"},
        { key: "gridIntegrado", label: "Grid interligado (GJ)"},
        { key: "sistemaIsolado", label: "Sistema isolado (GJ)"},

        { key: "observacao", label: "Observações"},
        { key: "createdAt", label: "Inserido"},
        { key: "updatedAt", label: "Atualizado"},
        
    ]
}
